import type { ControllerFirmware } from '@/features/controller/types'

const JAVA_APP_PACKAGE_NAME = 'raspi-app'
const RUST_APP_PACKAGE_NAME = 'controller-app'

export type ControllerApp = { kind: 'java' | 'rust' | 'other'; packageName: string } | { kind: 'unknown' }

/** Identifies which app the controller runs from the app package it reported at its last boot */
export function identifyControllerApp(firmware: ControllerFirmware): ControllerApp {
  const packageName = firmware.app.packageName
  if (!packageName) {
    return { kind: 'unknown' }
  }
  if (packageName === JAVA_APP_PACKAGE_NAME) {
    return { kind: 'java', packageName }
  }
  if (packageName === RUST_APP_PACKAGE_NAME) {
    return { kind: 'rust', packageName }
  }
  return { kind: 'other', packageName }
}
